import { Command } from '@ckeditor/ckeditor5-core';
import { findLinkRange } from './utils';
import LinkModal from '../../link-modal';
export default class InsertInternalLinkCommand extends Command {
    execute() {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        let publications = this.editor.config.get('internalLink.publications') || [];
        const linkModal = new LinkModal(publications.filter(({ linkType }) => linkType !== 'author'));
        if (!this.value) {
            if (selection.isCollapsed)
                return;
            linkModal
                .show()
                .then(({ linkType, publicationId }) => {
                const attribute = this.createAttribute(linkType, { publicationId });
                if (!attribute)
                    return;
                this.createLinkInModel(attribute);
            })
                .catch(() => { });
        }
        else {
            this.removeLinkInModel();
        }
    }
    createLinkInModel(attribute) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        model.change((writer) => {
            const ranges = model.schema.getValidRanges(selection.getRanges(), 'internalLink');
            for (const range of ranges) {
                writer.setAttribute('internalLink', attribute, range);
            }
        });
    }
    removeLinkInModel() {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const rangesToUnlink = selection.isCollapsed
            ? [findLinkRange(selection.getFirstPosition(), selection.getAttribute('internalLink'), model)]
            : selection.getRanges();
        model.change((writer) => {
            for (const range of rangesToUnlink) {
                writer.removeAttribute('internalLink', range);
            }
        });
    }
    createAttribute(linkType, options) {
        const { publicationId } = options;
        const attributeName = this.attributeNameByLinkType(linkType);
        if (!publicationId && !attributeName)
            return null;
        let attributeValue = '';
        if (publicationId) {
            attributeValue = publicationId;
        }
        else {
            attributeValue = linkType;
        }
        return {
            dataLinkType: linkType,
            [attributeName]: attributeValue,
        };
    }
    attributeNameByLinkType(linkType) {
        switch (linkType) {
            case 'example': // for support existing links
            case 'resume-example':
            case 'cover-letter-example':
                return 'dataExampleId';
            case 'post':
                return 'dataPostId';
            case 'blog-category':
            case 'resume-example-category':
            case 'cover-letter-example-category':
            case 'resume-template-category':
            case 'cover-letter-template-category':
                return 'dataResourceId';
            case 'home':
            case 'resume-builder-landing':
            case 'cover-letter-builder-landing':
            case 'blog-root':
            case 'resume-example-root':
            case 'cover-letter-example-root':
            case 'create-resume':
            case 'create-cover-letter':
                return 'dataLinkType';
        }
        return '';
    }
    refresh() {
        this.isEnabled = this.checkEnabled();
        this.value = this.checkSelectionAttribute('internalLink');
    }
    checkEnabled() {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        return (!this.checkSelectionAttribute('linkHref') &&
            schema.checkAttributeInSelection(selection, 'internalLink'));
    }
    checkSelectionAttribute(attribute) {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        if (selection.isCollapsed) {
            return selection.hasAttribute(attribute);
        }
        const attrArray = [];
        for (const range of selection.getRanges()) {
            for (const item of range.getItems()) {
                if (schema.checkAttribute(item, attribute)) {
                    attrArray.push(item.hasAttribute(attribute));
                }
            }
        }
        return attrArray.some(Boolean);
    }
}
